import { render, staticRenderFns } from "./SchoolUser.vue?vue&type=template&id=28d4f40a&scoped=true"
import script from "./SchoolUser.vue?vue&type=script&lang=js"
export * from "./SchoolUser.vue?vue&type=script&lang=js"
import style0 from "./SchoolUser.vue?vue&type=style&index=0&id=28d4f40a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d4f40a",
  null
  
)

export default component.exports